import { jsxs, jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { CardBannerWrapper, CardBannerFigure, CardBannerImage, CardBannerInner } from "./card-banner.styles.es.js";
const propTypes = {
  children: PropTypes.node,
  image: PropTypes.string
};
const defaultProps = {
  children: void 0,
  image: void 0
};
const CardBanner = ({ children, image }) => /* @__PURE__ */ jsxs(CardBannerWrapper, { children: [
  image && /* @__PURE__ */ jsx(CardBannerFigure, { children: /* @__PURE__ */ jsx(CardBannerImage, { src: image }) }),
  /* @__PURE__ */ jsx(CardBannerInner, { children })
] });
CardBanner.propTypes = propTypes;
CardBanner.defaultProps = defaultProps;
export {
  CardBanner
};
